import React, { useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../../scss/dashboard/dashInicio.css";
import Imagen2 from "../../images/dashboardAbogados/Imagen2.svg";

import ScoreImg from "../../images/dashboardAbogados/scoreimg.png";

import Inicioslider from "./Inicioslider";
import { NavLink } from "react-router-dom";
import IndexBoxOne from "./indexBoxes/IndexBoxOne";
import IndexBoxTwo from "./indexBoxes/IndexBoxTwo";
import AltIndexBoxThree from "./indexBoxes/AltIndexBoxThree";
import NoStatusScreen from "./indexBoxes/NoStatusScreen";
import { Table } from "./Table";
import { useRequestedTemplateList } from "../../api/hooks/templates";
import { useProfile } from "../../api/hooks/profile";
import { parseDate, getPrice } from "../../utils";
import { IndexTopSold } from "./PlantillasVendidas.js";
function DashInicio() {
  const { profile } = useProfile();
  const { data, isLoading } = useRequestedTemplateList({
    enabled: true,
    onlyMyTemplates: true,
  });
  const [topSoldIndex, setTopSoldIndex] = React.useState();

  const getTopSoldIndex = (data) => {
    let newObject = data
      ?.filter((x) => x.sold !== undefined)
      .sort((a, b) => b.sold - a.sold)
      .slice(0, 2);
    setTopSoldIndex(newObject);
  };
  useEffect(() => {
    getTopSoldIndex(data?.data);
    // console.log(data);
  }, [data]);

  return (
    <section className="dashInicio">
      <div className="saldo__texto">
        <h3 className="font-weight-bold">Total Saldo</h3>
      </div>
      <div className="saldo__texto">
        <h3 className="font-weight-bold">
          {data?.data?.length > 0 ? "Agregar plantilla" : "Agrega tu primera"}
        </h3>
      </div>
      <IndexBoxOne balance={profile.balance} />
      {(topSoldIndex?.length === 0 || !topSoldIndex?.length) && (
        <IndexBoxTwo
          templatesCount={profile.totalPublicTemplates}
          title={
            data?.data?.length > 0
              ? "Comienza a ganar dinero subiendo tus plantillas"
              : "Comienza a ganar dinero creando tu primera plantilla"
          }
        />
      )}
      {topSoldIndex?.length > 0 && <IndexTopSold />}

      <div className="normal">
        {/* Don´t Delete !!!!*/}

        {/* <AltIndexBoxThree /> */}
        <div className="inicio__box-slider">
          <Inicioslider
            title={
              data?.data?.length > 0
                ? "mi primera plantilla?"
                : "mi primera plantilla?"
            }
          />
        </div>
        <ScoreBox points={profile.points} />
      </div>
      <RequestedTemplatesTable />
    </section>
  );
}

export default DashInicio;

function ScoreBox({ points = 0 }) {
  if (points > 0) {
    return <div>Componente de puntos</div>;
  }

  return (
    <div className="ScoreBox">
      <span className="font-weight-bold">Mi puntaje</span>
      <h3 className="font-weight-bold">Como ganar puntos con mis plantillas</h3>
      <div>
        <img src={ScoreImg} alt="ScoreImg" />
      </div>

      <p>Con cada venta se sumaran puntos para obtener más beneficios</p>
    </div>
  );
}

function RequestedTemplatesTable({ sortBy }) {
  const { t } = useTranslation();
  const { data, isLoading } = useRequestedTemplateList({});

  const cols = useMemo(
    () => [
      {
        label: "ID",
        className: "table__id",
        render: (publicTemplate, i) => i + 1,
      },
      {
        label: "NOMBRE DE PLANTILLA",
        className: "table__name",
        key: "name",
      },
      {
        label: "ESTATUS",
        className: "",
        render: (requestedTemplate) => (
          <div className="table__status table__status--progress mostSells__views">
            <p>{t(`documentStatus.${requestedTemplate.status}`)}</p>
          </div>
        ),
      },
      {
        label: "PRECIO",
        className: "",
        render: (requestedTemplate) => (
          <div className="table__price mostSells__price">
            <p>
              {requestedTemplate.price > 0
                ? getPrice((requestedTemplate?.price || 0) * 100, "mxn")
                : t("free")}
            </p>
          </div>
        ),
      },
      {
        label: "VENTAS",
        className: "table__sells mostSells__sells",
        key: "sold",
        render: (requestedTemplate) => (
          <p>{requestedTemplate?.publicTemplate?.sold ?? 0}</p>
        ),
      },
      {
        label: "FECHA DE CREACIÓN",
        className: "table__date mostSells__date",
        render: (publicTemplate) => parseDate(publicTemplate.createdAt),
      },
    ],
    []
  );

  return (
    <Table isLoading={isLoading} items={data?.data} cols={cols} width={100} />
  );
}
